/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface BCMBookingIdRemarkRuleListQuery
 */
export interface BCMBookingIdRemarkRuleListQuery {
    /**
     * 
     * @type {boolean}
     * @memberof BCMBookingIdRemarkRuleListQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BCMBookingIdRemarkRuleListQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {boolean}
     * @memberof BCMBookingIdRemarkRuleListQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BCMBookingIdRemarkRuleListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BCMBookingIdRemarkRuleListQuery
     */
    limit?: number | null;
}

export function BCMBookingIdRemarkRuleListQueryFromJSON(json: any): BCMBookingIdRemarkRuleListQuery {
    return BCMBookingIdRemarkRuleListQueryFromJSONTyped(json, false);
}

export function BCMBookingIdRemarkRuleListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): BCMBookingIdRemarkRuleListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function BCMBookingIdRemarkRuleListQueryToJSON(value?: BCMBookingIdRemarkRuleListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showDisabled': value.showDisabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'showDeleted': value.showDeleted,
        'offset': value.offset,
        'limit': value.limit,
    };
}


